import { Component, EventEmitter, HostBinding, Injector, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl, ValidationErrors, Validator } from "@angular/forms";
import { animZoomInOut } from "@animations/zoom-in-out.anim";
import { ComponentUtility } from '@app/class/ComponentUtility';
import { noop } from "angular";
import "./checkbox.component.scss";

@Component({
    selector: 'v-checkbox',
    template: require('./checkbox.component.html'),
    animations: [animZoomInOut],
    providers: [
        ComponentUtility.createValueAccessorProvider(CheckboxComponent),
        ComponentUtility.createValidatorProvider(CheckboxComponent)
    ]
})
export class CheckboxComponent implements OnInit, ControlValueAccessor, Validator {

    @Input() checkedValue: any;
    @Input() icon: string;
    @Input() checked: boolean; // why is this here?

    @HostBinding("class.disabled") @Input() disabled: boolean;

    @Output() onChecked = new EventEmitter<any>();

    // ---

    //Placeholders for the callbacks which are later provided
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //get accessor
    get value(): any {
        return this.checkedValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.checkedValue) {
            this.checkedValue = v;
            this.onChangeCallback(v);
        }
    }

    //Set touched on blur
    onBlur() {
        this.onTouchedCallback();
    }

    // --- Control Value Accessor

    onChange: (value: any) => void;
    onTouched: () => void;
    control: NgControl;

    registerOnChange(callback: (value: any) => void): void {
        this.onChange = callback;
    }

    registerOnTouched(callback: () => void): void {
        this.onTouched = callback;
    }

    writeValue(value: string): void {
        this.checkedValue = value;
    }

    setDisabledState(state: boolean) {
        this.disabled = state;
    }

    markAsTouched(): void {
        if (!this.onTouched || !this.control || this.control.touched) {
            return;
        }

        this.onTouched();
    }
    // Validator

    validate(control: AbstractControl): ValidationErrors | null {
        this.control = this.injector.get(NgControl);

        return null;
    }

    constructor(private readonly injector: Injector) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onModelChange(value: any): void {
        this.emitValue();
    }

    toggleChecked(): void {
        if (this.disabled) {
            return;
        }

        this.checkedValue = !this.checkedValue;

        this.emitValue();
    }

    // ---

    private emitValue(): void {
        this.onChecked.emit(this.value);

        if (this.onChange) {
            this.onChange(this.value);
        }
    }
}
